@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">West Virginia</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <!-- Input fields -->
      <!-- @if (controls?.length >= 1) {
        <div class="axis-grid">
          @if (baseRules[controls[0].baseRuleKey]?.includes("show")) {
            <div class="axis-col-6">
              <div class="axis-form-group">
                <label class="axis-control-label">
                  {{ controls[0].label }}
                </label>
                <p>{{ reactiveForm.get(controls[0].formControlName)?.value }}</p>
              </div>
            </div>
          }
        </div>
      } -->
      <!-- Multi car discount readonly radio button-->
      @if (baseRules?.Multicar_LevelOne_Radio) {
        <div class="axis-form-group">
          <label class="axis-control-label">
            {{ textValues?.MultiCar_Text }}
          </label>
        </div>
      }
      <!-- UM Radio Group level two -->
      @if (controls?.length >= 4) {
        <div
          class="axis-form-group"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[3].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[3].formControlName)?.touched &&
              reactiveForm.get(controls[3].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[3].formControlName }}">
            @for (control of controls[3].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[3].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[3].formControlName)?.touched) {
              @if (reactiveForm.get(controls[3].formControlName)?.invalid) {
                <span
                  class="axis-error-block"
                  role="alert"
                  >Please select an option.</span
                >
              }
            }
          </axis-radio-button-wrapper>
        </div>
      }
      <!-- UM Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 5 : 11; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show") || baseRules[control.baseRuleKey]?.includes("form")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                </label>
                <axis-dropdown
                  (onSelect)="onSelect(control, baseRules['selectionId']);handleDropdownSelection(control, $event);"
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }
                @if (control.selectedPremium) {
                  <div [hidden]="!showPremium">Premium: {{ control.selectedPremium }}</div>
                }
              </div>
            </div>
          }
        }
      </div>
      <!-- Readonly Dropdowns -->
      <div class="axis-grid">
        @if ((baseRules?.["UMBI_SplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[8].label }}</label>
              <div id="umbi_splitminlimits_25k_50k-pdffield-west-virginia">
                {{ controls[8].data[0].name }}
              </div>
            </div>
          </div>
        }

        @if ((baseRules?.["UMBI_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[9].label }}</label>
              <div id="umbi_combinedsingleminlimit_25k-pdffield-west-virginia">
                {{ controls[9].data[0].name }}
              </div>
            </div>
          </div>
        }

        @if ((baseRules?.["UMBIUMPD_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[10].label }}</label>
              <div id="umbiumpd_combinedsingleminlimit_75k-pdffield-west-virginia">
                {{ controls[10].data[0].name }}
              </div>
            </div>
          </div>
        }
      </div>

      <!-- UIM Radio Group level two -->
      @if (controls?.length >= 5) {
        <div
          class="axis-form-group _mt-large"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[4].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[4].formControlName)?.touched &&
              reactiveForm.get(controls[4].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[4].formControlName }}">
            @for (control of controls[4].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[4].formControlName }}"
              ></axis-radio>
            }
            @if (reactiveForm.get(controls[4].formControlName)?.touched) {
              @if (reactiveForm.get(controls[4].formControlName)?.invalid) {
                <span
                  class="axis-error-block"
                  role="alert"
                  >Please select an option.</span
                >
              }
            }
          </axis-radio-button-wrapper>
        </div>
      }

      <!-- UIM Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 11; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show") || baseRules[control.baseRuleKey]?.includes("form")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                </label>
                <axis-dropdown
                  (onSelect)="handleDropdownSelection(control, $event)"
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }
                @if (control.selectedPremium) {
                  <div [hidden]="!showPremium">Premium: {{ control.selectedPremium }}</div>
                }
              </div>
            </div>
          }
        }
      </div>
      <!-- Readonly Dropdowns -->
      <div class="axis-grid">
        @if ((baseRules?.["UIMBI_SplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[14].label }}</label>
              <div id="uimbi_splitminlimits_25k_50k-pdffield-west-virginia">
                {{ controls[14].data[0].name }}
              </div>
            </div>
          </div>
        }

        @if ((baseRules?.["UIMBI_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[15].label }}</label>
              <div id="uimbi_combinedsingleminlimit_25k-pdffield-west-virginia">
                {{ controls[15].data[0].name }}
              </div>
            </div>
          </div>
        }

        @if ((baseRules?.["UIMBIUMPD_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[16].label }}</label>
              <div id="uimbiumpd_combinedsingleminlimit_75k-pdffield-west-virginia">
                {{ controls[16].data[0].name }}
              </div>
            </div>
          </div>
        }
      </div>
      <!-- Readonly Reject -->
      @if (baseRules?.RejectUIM_UIMBIUIMPD_LevelTwo_Radio?.includes("Yes")) {
        <div class="axis-form-group">
          <label
            id="rejectuim_uimbiuimpd_leveltwo_radio-pdffield-west-virginia"
            class="axis-control-label"
          >
            {{ textValues?.RejectUIM_Text }}
          </label>
        </div>
      }

      @if (baseRules?.SplitReject_UIMBIUIMPD_LevelTwo_Radio?.includes("Yes")) {
        <div class="axis-form-group">
          <label
            id="splitreject_uimbiuimpd_leveltwo_radio-pdffield-west-virginia"
            class="axis-control-label"
          >
            {{ textValues?.RejectUIM_Text }}
          </label>
        </div>
      }
    </form>
  }
}
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">West Virginia</h2>

  @if (baseRules?.Reject_LevelOne_UIM_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text }}
      </label>
      <div>{{ baseRules?.Reject_LevelOne_UIM_Radio }}</div>
    </div>
  }
  <!-- DROPDOWN VALUES -->
  <div class="axis-grid">
    @for (control of controls | slice: 4; track $index) {
      @if (baseRules[control.baseRuleKey]) {
        <div class="axis-col-sm-6 axis-col-lg-4">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ control.label }}</label>
            <div>{{ control.data[0].name }}</div>
          </div>
        </div>
      }
    }
  </div>

  <!-- Reject texts -->
  @if (baseRules?.RejectUIM_UIMBIUIMPD_LevelTwo_Radio || baseRules?.SplitReject_UIMBIUIMPD_LevelTwo_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text_UMPD }}
      </label>
    </div>
  }
  <!--UMPD Reject text-->
  @if (baseRules?.UMPDReject_LevelTwo_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text_UMPD }}
      </label>
      <div>{{ baseRules?.UMPDReject_LevelTwo_Radio }}</div>
    </div>
  }
}
